type Mode = "prod" | "dev" | "latest" | "canary";

function getMode(): Mode {
  if (window.location.host === "latest.mytour.tech") {
    return "latest";
  }
  if (window.location.host === "canary.mytour.tech") {
    return "canary";
  }
  if (window.location.host === "mytour.tech" || window.location.host === "app.mytour.tech") {
    return "prod";
  }
  return "dev";
}
export const envService = {
  getMode,
};
